/** Returns the asset path for a provider icon, or null when not recognised. */
export function getProviderIconSrc(
  provider: string | null | undefined,
  /** serviceType (transfers) or transferType (corrections) — 'AIRTIME' triggers the airtime icon */
  typeHint?: string | null,
): string | null {
  if (!provider) return null;
  if (provider === '62401' && typeHint === 'AIRTIME') return '/assets/icons/mtn_airtime_active.png';
  if (provider === '62402' && typeHint === 'AIRTIME') return '/assets/icons/orange_airtime_active.png';
  if (provider === '62401' && typeHint === 'MOBILE_MONEY') return '/assets/icons/mtn_active.png';
  if (provider === '62402' && typeHint === 'MOBILE_MONEY') return '/assets/icons/orange_active.png';
  if (provider === '62401') return '/assets/icons/mtn_active.png';
  if (provider === '62402') return '/assets/icons/orange_active.png';
  if (provider === 'DIOOL') return '/assets/icons/diool-icon.png';
  if (provider === 'BANK') return '/assets/icons/bank-icon.png';
  if (provider === 'EUMM') return '/assets/icons/eumm-icon.jpg';
  if (provider === '62404') return '/assets/icons/nexttel.png';
  return null;
}
